import actions, { Actions } from './actions';
import entityTypes, { KnownEntityTypes } from './entityTypes';

const entityListPermissionMap: Record<KnownEntityTypes, Actions> = {
  [entityTypes.ACCOUNT]: actions.ACCOUNT_ENTITY_LIST,
  [entityTypes.BUSINESS]: actions.BUSINESS_LIST,
  [entityTypes.CAR]: actions.CAR_LIST,
  [entityTypes.INDIVIDUAL]: actions.INDIVIDUAL_LIST,
  [entityTypes.PRODUCT]: actions.PRODUCT_LIST,
};

export default entityListPermissionMap;
